/**
 * BACKGROUNDS.JS - Configuration des backgrounds disponibles
 * 
 * Ce fichier définit tous les backgrounds (arrière-plans) disponibles
 * dans l'application. Chaque background configure :
 * - Le dégradé du Floor (couleur haut/bas)
 * - L'effet de glow (position, couleur, opacité)
 * 
 * UTILISATION :
 * - Import : import { backgrounds } from './config/backgrounds'
 * - Ajouter un nouveau background : ajouter un objet dans le tableau
 * 
 * STRUCTURE D'UN BACKGROUND :
 * {
 *   id: string,              // Identifiant unique
 *   name: string,            // Nom affiché dans l'interface
 *   gradient: {
 *     top: string,           // Couleur hexadécimale du haut
 *     bottom: string         // Couleur hexadécimale du bas
 *   },
 *   glow: {
 *     color: string,         // Couleur hexadécimale du glow
 *     positionX: number,     // Position X (0-1)
 *     positionY: number,     // Position Y (0-1)
 *     radius: number,        // Rayon du glow (0-2)
 *     alpha: number          // Opacité du glow (0-1)
 *   },
 *   shadowColor: string      // Couleur des ombres au sol (hexadécimal)
 * }
 */

export const backgrounds = [
  {
    id: 'lovely-tomato',
    name: 'Lovely Tomato',
    gradient: {
      top: '#d10505',
      bottom: '#ff3b3b'
    },
    glow: {
      color: '#f3f5da',
      positionX: 0.7,
      positionY: 0.6,
      radius: 0.52,
      alpha: 0.6
    },
    shadowColor: '#c41d1d'
  },
  {
    id: 'sweet-mustard',
    name: 'Sweet Mustard',
    gradient: {
      top: '#ffad33',
      bottom: '#e5bc18'
    },
    glow: {
      color: '#f3f5da',
      positionX: 0.7,
      positionY: 0.6,
      radius: 0.52,
      alpha: 0.6
    },
    shadowColor: '#c46f1d'
  },
  {
    id: 'purple-dream',
    name: 'Purple Dream',
    gradient: {
      top: '#8064cc',
      bottom: '#5423e6'
    },
    glow: {
      color: '#ffa1c2',
      positionX: 0.62,
      positionY: 0.42,
      radius: 0.71,
      alpha: 0.68
    },
    shadowColor: '#6f0559'
  },
  {
    id: 'just-dark',
    name: 'Just Dark',
    gradient: {
      top: '#212121',
      bottom: '#383838'
    },
    glow: {
      color: '#ffffff',
      positionX: 0.62,
      positionY: 0.56,
      radius: 0.60,
      alpha: 0.14
    },
    shadowColor: '#333333'
  },
  {
    id: 'ocean-breeze',
    name: 'Ocean Breeze',
    gradient: {
      top: '#b3e6d7',
      bottom: '#40e0d0'
    },
    glow: {
      color: '#40e0d0',
      positionX: 0.55,
      positionY: 0.53,
      radius: 0.36,
      alpha: 0.52
    },
    shadowColor: '#005f73'
  },
  {
    id: 'sunset-pop',
    name: 'Pop Sunset',
    gradient: {
      top: '#ff3cac',
      bottom: '#fee140'
    },
    glow: {
      color: '#ffd89b',
      positionX: 0.7,
      positionY: 0.6,
      radius: 0.52,
      alpha: 0.6
    },
    shadowColor: '#d62828'
  },
  {
    id: 'the-beach',
    name: 'The Beach',
    gradient: {
      top: '#7ac1db',
      bottom: '#dbdaac'
    },
    glow: {
      color: '#00ff49',
      positionX: 0.5,
      positionY: 0.5,
      radius: 0.5,
      alpha: 0.3
    },
    shadowColor: '#2a9d8f'
  },
  {
    id: 'fresh-green',
    name: 'Fresh Green',
    gradient: {
      top: '#d4ff00',
      bottom: '#89ff00'
    },
    glow: {
      color: '#e6fff4',
      positionX: 0.62,
      positionY: 0.57,
      radius: 0.63,
      alpha: 0.72
    },
    shadowColor: '#4da303'
  },
  {
    id: 'pinky-powa',
    name: 'Pink Powa',
    gradient: {
      top: '#ff007a',
      bottom: '#ff2ec2'
    },
    glow: {
      color: '#e6fff4',
      positionX: 0.62,
      positionY: 0.57,
      radius: 0.6,
      alpha: 0.72
    },
    shadowColor: '#d62828'
  }
]

/**
 * Récupère un background par son ID
 * @param {string} id - L'ID du background à récupérer
 * @returns {object|null} Le background trouvé ou null
 */
export function getBackgroundById(id) {
  return backgrounds.find(bg => bg.id === id) || null
}

/**
 * Récupère le background par défaut (premier de la liste)
 * @returns {object} Le background par défaut
 */
export function getDefaultBackground() {
  return backgrounds[0]
}

